import Swal from "sweetalert2";
import axios from "../../axios";
import { setAlert } from "./alert";
import { ADD_GL_GROUP, DELETE_GL_GROUP, GET_GL_GROUPS, UPDATE_GL_GROUP } from "../types";
import { getErrorMessage } from "../../helpers/ErrorMessage";

export const addGlGroup = (formData) => async (dispatch) => {
  try {
    const res = await axios.post("gl/add", formData);
    if (res.data.code === 1) {
      dispatch({ type: ADD_GL_GROUP, payload: res.data.data });
      Swal.fire({
        title: 'Success!',
        text: res.data.message,
        icon: 'success',
      });
      dispatch(setAlert(res.data.message, "success"));
      if (res.data.code === 0) {
        console.log("here :", res.data.message);
        Swal.fire({
          title: 'warning!',
          text: res.data.message,
          icon: 'warning',
        });
      }
    } else {
      dispatch(setAlert(res.data.message, "warning"));
      Swal.fire({
        title: 'warning!',
        text: res.data.message,
        icon: 'warning',
      });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
    // const errorMessage =
    //   err.response?.data?.message || "An unexpected error occurred";
    const errorMessage = getErrorMessage(err.response?.data);

    Swal.fire({
      title: "Error!",
      text: errorMessage,
      icon: "error",
    });
  }
};
export const getGlGroup = () => async (dispatch) => {
  try {
    const res = await axios.get("gl/all");
    console.log("state :", res.data);
    if (res.data.code === 1) {
      dispatch({ type: GET_GL_GROUPS, payload: res.data.data });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};


export const updateGlGroup = (formData) => async (dispatch) => {
  try {

    const updatedFormData = {
      id: formData.id,
      ...(formData.name && { name: formData.name }),
      ...(formData.parentId !== undefined && { parentId: formData.parentId }),
      ...(formData.ordinalIndex !== undefined && { ordinalIndex: formData.ordinalIndex }),
    };

    const res = await axios.post("gl/update", updatedFormData);
    if (res.data.code === 1) {
      dispatch({ type: UPDATE_GL_GROUP, payload: res.data.data });
      Swal.fire({
        title: 'Success!',
        text: res.data.message,
        icon: 'success',
      });
      dispatch(setAlert(res.data.message, "success"));
    } else {
      dispatch(setAlert(res.data.message, "warning"));
      Swal.fire({
        title: 'warning!',
        text: res.data.message,
        icon: 'warning',
      });
    }
  } catch (err) {
    const errorMessage = getErrorMessage(err.response?.data);
    dispatch(setAlert(errorMessage, "danger"));
    Swal.fire({
      title: 'Error!',
      text: errorMessage,
      icon: 'error',
    });
  }
};

export const deleteGlGroup = (id) => async (dispatch) => {
  try {
    if (!id) {
      dispatch(setAlert("Please select any record", "warning"));
      return false;
    }
    const res = await axios.post(`gl/delete/${id}`);
    if (res.data.code === 1) {
      dispatch({ type: DELETE_GL_GROUP, payload: { id } });
      Swal.fire({
        title: 'Success!',
        text: res.data.message,
        icon: 'success',
      });
      dispatch(setAlert(res.data.message, "success"));
    } else {
      dispatch(setAlert(res.data.message, "warning"));
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};
